import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { AnimatePresence, motion } from "framer-motion"

function CategorySelector({ showSelectors, setShowSelectors }) {
  const categories = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { fields: frontmatter___order, order: ASC }
        filter: { frontmatter: { type: { eq: "category" } } }
      ) {
        edges {
          node {
            id
            frontmatter {
              title
              slug
            }
          }
        }
      }
    }
  `)
  return (
    <AnimatePresence>
      {showSelectors && (
        <motion.div
          variants={selectorBackdropVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          style={selectorBackdropStyle}
        >
          <motion.div
            variants={selectorContainerVariants}
            className="bg-light p-1"
            style={selectorListStyle}
          >
            <div className="d-flex align-items-center text-dark border-bottom border-dark mx-1 py-1">
              <h4 className="text-danger ml-2">Categories</h4>
              <motion.i
                variants={titleVariants}
                whileHover="onHover"
                whileTap="onTap"
                onClick={() => setShowSelectors(false)}
                style={{ cursor: "pointer" }}
                className="fas fa-times ml-auto mr-2 pb-2"
              ></motion.i>
            </div>
            <div className="d-block p-2">
              {categories.allMarkdownRemark.edges.map(({ node }, index) => (
                <Link
                  key={node.id}
                  to={`/category/${node.frontmatter.slug}`}
                  className="text-decoration-none text-dark my-2"
                >
                  <motion.h5
                    variants={titleVariants}
                    whileHover="onHover"
                    whileTap="onTap"
                  >
                    {node.frontmatter.title}
                  </motion.h5>
                  {index !== categories.allMarkdownRemark.edges.length - 1 && (
                    <hr />
                  )}
                </Link>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CategorySelector

const selectorBackdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  zIndex: 100,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}

const selectorBackdropVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
    transition: {
      delay: 0.8,
      ease: "easeInOut",
    },
  },
}

const selectorListStyle = {
  width: "100%",
  maxWidth: "350px",
  borderRadius: "10px",
}

const selectorContainerVariants = {
  hidden: {
    scale: 0,
  },
  visible: {
    scale: 1,
    transition: {
      delay: 0.2,
      duration: 0.5,
    },
  },
  exit: {
    scale: 0,
    transition: {
      delay: 0.2,
      duration: 0.5,
      ease: "easeInOut",
    },
  },
}

const titleVariants = {
  onHover: {
    opacity: 0.8,
    scale: 1.1,
  },
  onTap: {
    scale: 0.8,
  },
}
